import React, { Component } from 'react'
import { connect } from 'react-redux';

// child Component
import OtherSection from './OtherSection'
import ParticipantSection from './ParticipantSection'
import ContactSection from './ContactSection'
import { caseMenuInfo } from './actions/actionCreator';
import { eapiClient, aemHostClient } from '../../../restClient';
import { Translations, convertStringToArray } from '../../../utils';
// css files
import './CaseMenu.css'

class CaseMenu extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pageJson: ''
    };
  }

  componentWillMount() {
    let caseId;
    aemHostClient("/aemData/formData/json_case-menu")
      .then(({ data }) => {
        this.setState({
          pageJson: data.par
        })
      });
    if (this.props.caseId === '') {
      caseId = this.props.history.location.state.Urn
    }
    else {
      caseId = this.props.caseId
    }
    let url
    if (this.props.history.location.pathname.includes("sow-body")) {
      let agentDetail = this.props.sowEntities.filter(entity => {
        return entity.agent
      })

      url = '/sows/' + agentDetail[0].groupId + '/menu'
    } else {
      url = '/cases/' + caseId + '/menu'
    }

    eapiClient(url)
      .then(({ data }) => {
        this.setState({ caseMenu: data.responseData }, () => {
          this.props.caseMenuInfo(data.responseData)
        });
      });

    aemHostClient("/aemData/formData/json_revoked-user-access")
      .then(({ data }) => {
        this.setState({ modalRevokedAccessJson: data.par });
      });

  }
  // componentWillReceiveProps(nextProps){
  //     this.setState({
  //         caseMenu: nextProps._getData
  //     })
  // }
  //
  // setUpdatedValue = (value) => {
  //     this.setState({
  //         caseMenu: value.caseMenu
  //     })
  // }


  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }


  render() {
    // let data = this.props._getData;
    if (this.state.pageJson !== '' && this.props.caseMenu.caseOwner !== 'undefined') {
      const Urn = Object.keys(this.props.cases)[0];
      const { entities, auth } = this.props;
      //const participantNames = ['Nawaf Hasan', 'Robert Jones']

      return (
        <div className="case-menu">
          {
            this.state.modalRevokedAccessJson !== undefined
              ?
              <ParticipantSection
                headerTitle={this.translateWord(this.state.pageJson.text_data_caseMenu.fieldLabels)[3]}
                sowHeaderTitle={Translations(this.state.pageJson.text_data_caseMenu.sowParticipants, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                data={entities}
                caseParticipants={typeof this.props.caseMenu.caseParticipants !== 'undefined' ? this.props.caseMenu.caseParticipants : ''}
                history={this.props.history}
                getUpdatedCaseMenuValue={this.setUpdatedValue}
                modalRevokedAccessJson={this.state.modalRevokedAccessJson}
                lang={this.props.lang}
                sow={this.props.sow}
                sowEntities={this.props.sowEntities}
              />
              : null
          }
          <ContactSection
            headerTitle={this.translateWord(this.state.pageJson.text_data_caseMenu.fieldLabels)[0]}
            data={auth}
            caseOwner={typeof this.props.caseMenu.caseOwner !== 'undefined' ? this.props.caseMenu.caseOwner : ''}
            lang={this.props.lang}
          />
          <OtherSection
            history={this.props.history}
            caseHistory={this.translateWord(this.state.pageJson.text_data_caseMenu.fieldLabels)[2]}
            sowHistory={Translations(this.state.pageJson.text_data_caseMenu.sowHistory, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
            supportingDocs={this.translateWord(this.state.pageJson.text_data_caseMenu.fieldLabels)[4]}
            customerGuide={this.translateWord(this.state.pageJson.text_data_caseMenu.fieldLabels)[6]}
            label={Translations(this.state.pageJson.text_data_caseMenu.label, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
            headerTitle={this.translateWord(this.state.pageJson.text_data_caseMenu.fieldLabels)[1]}
            sowHeaderTitle={Translations(this.state.pageJson.text_data_caseMenu.sowMenu, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
            Urn={Urn}
            lang={this.props.lang}
            productType={this.props.productType}
            sow={this.props.sow}
            sowEntities={this.props.sowEntities}
            Cashcon_Guide={this.translateWord(this.state.pageJson.text_data_caseMenu.fieldLabels)[7]}
            NP_Guide={this.translateWord(this.state.pageJson.text_data_caseMenu.fieldLabels)[8]}
            IE_Guide={this.translateWord(this.state.pageJson.text_data_caseMenu.fieldLabels)[9]}
          />
        </div>
      )
    } else {
      return null;
    }
  }
}

CaseMenu.defaultProps = {
  caseId: '',
  entities: [],
  auth: {}
}

const mapStateToProps = state => {
  return {
    caseMenu: state.caseMenuInfo,
    cases: state.cases
  }
}

const mapDispatchToProps = dispatch => {
  return {
    caseMenuInfo: caseMenuData => {
      dispatch(caseMenuInfo(caseMenuData))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CaseMenu);



// WEBPACK FOOTER //
// ./src/components/common/CaseMenu/CaseMenu.js